import React, { createContext, useContext } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { AuthContext } from './AuthContext';
import config from '../config';

const FetchContext = createContext();
const { Provider } = FetchContext;

function FetchProvider({ children }) {
  const { state } = useContext(AuthContext);
  const authAxios = axios.create({
    baseURL: config.API_URL
  });

  authAxios.interceptors.request.use(
    (config) => {
      config.headers.Authorization = `Bearer ${state.token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  authAxios.interceptors.response.use(
    (response) => response,
    (error) => {
      const code = error && error.response ? error.response.status : 0;
      if (code === 401 || code === 403) {
        console.log('error code', code);
      }
      return Promise.reject(error);
    }
  );

  return (
    <Provider
      value={{
        authAxios
      }}
    >
      {children}
    </Provider>
  );
}

export { FetchContext, FetchProvider };

FetchProvider.propTypes = {
  children: PropTypes.any
};
